function elmExists(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}


function openCartAside(cartDetails) {
  try {
    const {side, asideClass, setterClass} = cartDetails;
    $(setterClass).addClass(`${asideClass}-${side}`);

    // Set Aria States
    const cartIcon = document.querySelector(".cart-item.header-link");
    if(cartIcon && window.A11Y && window.A11Y.setAriaExpanded){
      window.A11Y.setAriaExpanded(cartIcon, true);
    }

    const findMenuContent = document.querySelector('#shopify-section-cart-aside .menu-content');

    if (findMenuContent) {
      findMenuContent.removeAttribute('inert');
    }

    // Wait for checkout button to exist (handles PDP async rendering), then focus and announce
    // Smart checkout button selection with broader selectors and Route fallback
    const getCheckoutButton = () => {
      // Check for visible Route buttons first
      const routeButtons = document.querySelectorAll('.menu-content .footer-row .actions a[data-route-copy], .menu-content .footer-row .actions a[data-route-href]');
      for (const routeButton of routeButtons) {
        const isVisible = routeButton.offsetWidth > 0 && 
                         routeButton.offsetHeight > 0 && 
                         !routeButton.style.display?.includes('none') &&
                         routeButton.getAttribute('aria-hidden') !== 'true';
                         
        if (isVisible) {
          console.log('Found visible Route button:', routeButton);
          // Don't force changes - Route is managing this button
          return routeButton;
        }
      }
      
      // Check for Route buttons that exist but might be hidden (fallback)
      const hiddenRouteButton = document.querySelector('.menu-content .footer-row .actions a[data-route-copy], .menu-content .footer-row .actions a[data-route-href]');
      if (hiddenRouteButton) {
        console.log('Found hidden Route button, making it visible:', hiddenRouteButton);
        hiddenRouteButton.style.display = '';
        hiddenRouteButton.removeAttribute('aria-hidden');
        hiddenRouteButton.removeAttribute('tabindex');
        
        // Hide the original checkout button to prevent duplicates
        const originalButton = document.querySelector('.menu-content .footer-row .actions a[href="/checkout"], .menu-content .footer-row .actions a#checkout');
        if (originalButton) {
          originalButton.style.display = 'none';
          originalButton.setAttribute('aria-hidden', 'true');
          originalButton.setAttribute('tabindex', '-1');
        }
        
        return hiddenRouteButton;
      }
      
      // No Route button found - look for standard checkout buttons
      const selectors = [
        // Standard checkout links
        '.menu-content .footer-row .actions a.button-brand--primary[href*="checkout"]', 
        // Generic checkout links with ID
        '.menu-content .footer-row .actions a#checkout',
        // Generic checkout links
        '.menu-content .footer-row .actions a[href*="checkout"]',
        // Checkout buttons (not links)
        '.menu-content .footer-row .actions button:not([disabled])',
        // Any primary buttons as last resort
        '.menu-content .footer-row .actions .button-brand--primary'
      ];
      
      for (const selector of selectors) {
        const button = document.querySelector(selector);
        if (button) {
          console.log(`Found standard checkout button with selector: ${selector}`, button);
          
          // Force show the button regardless of current visibility
          button.style.display = '';
          button.removeAttribute('aria-hidden');
          button.removeAttribute('tabindex');
          
          return button;
        }
      }
      
      console.warn('No visible checkout button found with any selector');
      return null;
    };
    
    elmExists('.actions').then(() => {
      try {
        // Delay to allow cart.js trapFocus to complete, then set our focus
        setTimeout(() => {
          try {
            const checkout = getCheckoutButton();
            if (!checkout) {
              console.warn('No checkout button found after timeout');
              return;
            }

            // Override any stored activeElement to prevent CartJS from restoring focus to ATC button
            const drawerContainer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
            if (drawerContainer && drawerContainer.setActiveElement) {
              drawerContainer.setActiveElement(checkout);
            }

            // Use the new W3C-based focus trap
            if (window.A11Y && window.A11Y.trapFocus) {
              window.A11Y.trapFocus(drawerContainer, checkout, {
                escapeDeactivates: false, // Cart aside should not close on escape
                allowOutsideClick: true
              });
            } else {
              // Fallback to old implementation if new one isn't loaded yet
              trapFocus(drawerContainer, checkout);
            }
            console.log('Initial focus set on:', checkout);
            
            // Set up MutationObserver to watch for Route button changes
            const actionsContainer = document.querySelector('.menu-content .footer-row .actions');
            if (actionsContainer) {
              let observerTimeout;
              
              const observer = new MutationObserver((mutations) => {
                console.log('MutationObserver detected changes in actions container');
                
                // Debounce rapid changes (Route might make multiple quick changes)
                clearTimeout(observerTimeout);
                observerTimeout = setTimeout(() => {
                  const currentlyFocused = document.activeElement;
                  const newCheckout = getCheckoutButton();
                  
                  // Check if we need to update focus
                  if (newCheckout && newCheckout !== currentlyFocused) {
                    console.log('Route changed checkout buttons, switching focus to:', newCheckout);
                    // Ensure focus is trapped inside the cart aside while open
                    try {
                      if (drawerContainer) {
                        if (window.A11Y && window.A11Y.trapFocus) {
                          console.log(`wpro_debug__Cart Aside:: NEW TRAP`);
                          window.A11Y.trapFocus(drawerContainer, newCheckout, {
                            escapeDeactivates: false,
                            allowOutsideClick: true
                          });
                        } else if (typeof trapFocus === 'function') {
                          console.log(`wpro_debug__Cart Aside:: FALLBACK TRAP`);
                          trapFocus(drawerContainer, newCheckout);
                        }
                      }
                    } catch (e) {
                      console.error('Error applying trapFocus to cart aside:', e);
                    }
                    newCheckout.focus();
                  } else if (!newCheckout) {
                    console.warn('No checkout button found after Route changes');
                  } else {
                    console.log('Current focus is still correct after Route changes');
                  }
                }, 100); // Small debounce delay
              });
              
              // Watch for changes to child elements and their attributes
              observer.observe(actionsContainer, {
                childList: true,        // Watch for added/removed buttons
                attributes: true,       // Watch for style/aria changes
                attributeFilter: ['style', 'aria-hidden', 'tabindex', 'class'],
                subtree: true          // Watch all descendants
              });
              
              // Clean up observer after 5 seconds (Route should be done by then)
              setTimeout(() => {
                observer.disconnect();
                console.log('MutationObserver cleanup completed');
              }, 5000);
              
              console.log('MutationObserver set up to monitor checkout button changes');
            }

            // Announce cart status for screen readers
            if (window.A11Y && window.A11Y.announce) {
              const count = (window.CartJS && CartJS.cart && CartJS.cart.item_count) ? CartJS.cart.item_count : '';
              const msg = count ? `${count} item${count === 1 ? '' : 's'} in cart` : 'Cart updated';
              window.A11Y.announce(msg, 'polite', 'CartDrawer-LiveRegionText');
            }
          } catch(e) {
            console.error('Error in openCartAside main flow:', e);
          }
        }, 500); // Wait for cart.js trapFocus and transitions to complete
      } catch(e) {
        console.error('Error in openCartAside elmExists handler:', e);
      }
    }).catch((e) => {
      console.error('Error waiting for .actions container:', e);
    });
  } catch(e) {
    console.error('Error in openCartAside:', e);
  }
}

function closeCartAside(cartDetails) {
  const {side, asideClass, setterClass} = cartDetails;
  $(setterClass).removeClass(`${asideClass}-${side}`);

  // Set Aria States  
  const cartIcon = document.querySelector(".cart-item.header-link");
  if(cartIcon && window.A11Y && window.A11Y.setAriaExpanded){
    window.A11Y.setAriaExpanded(cartIcon, false);
  }

  // Remove any focus trap applied to the cart aside and restore focus
  try {
    const drawerContainer = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    
    if (window.A11Y && window.A11Y.removeFocusTrap) {
      // Use the new W3C-based focus trap removal
      const returnFocusElement = cartIcon || document.activeElement;
      window.A11Y.removeFocusTrap(drawerContainer, true);
      if (returnFocusElement && window.A11Y.attemptFocus) {
        window.A11Y.attemptFocus(returnFocusElement);
      }
    } else if (typeof removeTrapFocus === 'function') {
      // Fallback to old implementation
      if (drawerContainer && drawerContainer.activeElement) {
        removeTrapFocus(drawerContainer.activeElement);
      } else {
        removeTrapFocus(cartIcon);
      }
    }
  } catch (e) {
    console.error('Error removing trapFocus on cart aside close:', e);
  }

  const findMenuContent = document.querySelector('#shopify-section-cart-aside .menu-content');

  if (findMenuContent) {
    findMenuContent.setAttribute('inert', '');
  }
}

$(function() {
  let carouselLoaded = false

  const setterClass = 'body'
  const asideClass = 'sidemenu-open'
  const isCartEmpty = () => CartJS.cart.item_count === 0;
  const isCart = () => document.body.classList.contains('template-cart');
  const handleMenuClose = (side) => {closeCartAside({side, asideClass, setterClass});}
  const handleMenuOpen = (side) => {openCartAside({side, asideClass, setterClass});}

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;

    const side = 'right';
    const className = `${asideClass}-${side}`;

    if ($(setterClass).hasClass(className)) {
      event.preventDefault();
      handleMenuClose(side);
    }
  });

  const delay = {
    minicart: 750,
    cart: 2500
  }
  
  const handleMenuToggle = (side) => {
    const className = `${asideClass}-${side}`
  
    if($(setterClass).hasClass(className)) {
      closeCartAside({side, asideClass, setterClass});
    } else {
      openCartAside({side, asideClass, setterClass});
    }
  }

  $('[data-sidemenu-close]').on('click', function(e) {
    e.preventDefault();
    handleMenuClose($(this).data('sidemenu-close'))
  })

  $('[data-sidemenu-open]').on('click', function(e) {
    e.preventDefault();
    handleMenuToggle($(this).data('sidemenu-open'))

    if(!isCartEmpty()) {
      setTimeout(() => {
        initCrossellApp();
      }, delay.minicart);
    }
  })

  // Rewards
  // --------------------
  function getRewardsValue() {
    const subtotalText = $('#subTotal').first().text() || '0'
    const subtotal = parseFloat(subtotalText.replace(/[^0-9.]/g, ''))

    return Number.isNaN(subtotal) ? 0 : Math.ceil(subtotal)
  }

  function setRewardsValue() {
    const rewardsVal = $('[data-cart-rewards-value]')

    rewardsVal.text(getRewardsValue())
  }

  // Cart
  // --------------------
  function handleCartContentState() {
    if(isCartEmpty()) {
      $('.cart-bubble').removeClass('active')
      $('.aside-menu-cart footer').hide();
    } else {
      $('.cart-bubble').addClass('active')
      $('.aside-menu-cart footer').show();
    }

    setRewardsValue()
  }

  handleCartContentState();

  $(document).on('cart.requestComplete', function(event, cart) {
    handleCartContentState();

    if (!isCart()) {
      handleMenuOpen('right');

      setTimeout(() => {
        initCrossellApp();
      }, delay.minicart);

      if(isCartEmpty()) {
        handleMenuClose('right');
      }
    }
  });

  if (isCart()) {
    setTimeout(() => {
      initCrossellApp();
    }, delay.cart);
  }

  // In Cart Upsell & Cross Sell app
  // https://apps.shopify.com/in-cart-upsell
  function initCrossellApp() {
    const appId = 148064
    const nudgeAppId = '[id^=nudge-offer-]'
    const nudgeAppWrapper = $(nudgeAppId)
    const nudgeAppAddToCartbtn = nudgeAppWrapper.find('button.bttn')
    const carousel = $('[id^=nudge-offer-] .offer-collection')
    const loadedClassName = 'is-loaded'

    const carouselOptions = {
      margin: 0,
      nav: true,
      navRewind: false,
      dots: false,
      autoplay: false,
      loop: false,
      items: 2,
      margin: 44, // var(--aside-menu-xpad)
      stagePadding: 44,
      navText: [
        "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Chevron Back</title><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M328 112L184 256l144 144'/></svg>",
        "<svg xmlns='http://www.w3.org/2000/svg' class='ionicon' viewBox='0 0 512 512'><title>Chevron Forward</title><path fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M184 112l144 144-144 144'/></svg>"
      ],
      onInitialized: isInitialized
    }

    const carouselCartOptions = {
      ...carouselOptions,
      responsive: {
        0: {
          items : 2,
        },
        768: {
          items : 3,
        },
        992: {
          items : 4,
          stagePadding: 0,
        },
        // 1140: {
        //   items : 5,
        // }
      }
    }

    const initCarousel = () => carousel.owlCarousel(isCart() ? carouselCartOptions : carouselOptions)

    if(isCartEmpty()) {
      carouselLoaded = false
      return
    }

    if (carouselLoaded) {
      carousel.trigger('refresh.owl.carousel')
      return
    }

    function isInitialized() {
      carouselLoaded = true

      if (carouselOptions.dots) {
        appIdElm.addClass('has-dots');
      }

      // Add loaded class to position carousel
      nudgeAppWrapper.addClass(loadedClassName)

      // remove default app add to cart onClick event
      nudgeAppAddToCartbtn.removeAttr('onclick')

      // Refresh to set correct widths in chrome
      carousel.trigger('refresh.owl.carousel')

      // Add to cart using CartJs
      nudgeAppAddToCartbtn.on('click', function(e){
        e.preventDefault();
        this.blur()
        const productId = $(this).closest('.variants').find('.variants-wrapper select option:first').val()

        if (productId) {
          CartJS.addItem(productId, quantity = 1);
        } else {
          console.log('Error, can\'t find productID')
        }
      })
    }

    function loadCarousel() {
      elmExists(nudgeAppId).then((e) => {
        nudgeAppWrapper.removeClass();

        initCarousel()
      })
    }

    if (!carouselLoaded) {
      loadCarousel()
    }
  }

  // Gift card recipient -> ensure CartJS receives line item properties
  function collectProperties(form) {
    const properties = {};

    form.querySelectorAll('[name^="properties["]').forEach((el) => {
      if (el.disabled) return;
      if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return;

      const m = el.name.match(/^properties\[(.*)\]$/);
      if (!m) return;

      const key = m[1];
      const value = (el.value || "").trim();
      if (!value) return;

      properties[key] = value;
    });

    return properties;
  }

  document.addEventListener(
    "click",
    function (e) {
      const btn = e.target.closest("[data-cart-add]");
      if (!btn) return;

      const form = btn.closest("form");
      if (!form) return;

      // Only intercept for the gift card recipient UI block
      const gcWrap = form.querySelector("[data-gc-recipient]");
      if (!gcWrap) return;

      // Only when "Send this as a gift" is enabled
      const toggle = gcWrap.querySelector("[data-gc-recipient-toggle]");
      if (!toggle || !toggle.checked) return;

      // We handle the add-to-cart ourselves (with properties)
      e.preventDefault();
      e.stopImmediatePropagation();

      if (!window.CartJS || typeof window.CartJS.addItem !== "function") {
        form.submit();
        return;
      }

      const variantId = parseInt(btn.getAttribute("data-cart-add"), 10);

      const qtyInput = form.querySelector('input[name="quantity"]');
      const quantity =
        (qtyInput && parseInt(qtyInput.value, 10)) ||
        parseInt(btn.getAttribute("data-cart-quantity"), 10) ||
        1;

      const properties = collectProperties(form);

      CartJS.addItem(variantId, quantity, properties);
    },
    true // capture so we run before rivets-cart / other delegated handlers
  );
});
